import { cn } from '@seen/ui'
import type { ReactNode } from 'react'

export interface InboxRowIconProps {
  children: ReactNode
  className?: string
}

export function InboxRowIcon({
  children,
  className,
}: InboxRowIconProps): ReactNode {
  return (
    <div
      className={cn(
        '-bottom-1 -right-1 absolute rounded-full border-2 border-background bg-gray-500 p-[0.5px] group-hover:border-accent group-focus:border-accent',
        className
      )}
    >
      {children}
    </div>
  )
}
